module.exports = __webpack_public_path__ + "static/media/info.b71b3a38.svg";